import PropTypes from 'prop-types';
import React from 'react';

import { getComponentFromName } from '../../lib/utils';

import ErrorPage from './Error';
import Page from './Page';
import * as Pages from './index';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }), error: PropTypes.bool };

function Loader({ page = null, error = false }) {
    if (error) {
        return <ErrorPage statusCode={404} />;
    }
    const { type = null } = page || {};
    const TypedPage = getComponentFromName(type, Pages, Page);
    return TypedPage !== null ? <TypedPage page={page} /> : null;
}

Loader.propTypes = propTypes;

export default Loader;
